import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconDownload } from '../../../assets/svg/shared/icon-download.svg';
import Button from '../../../generic-components/Button';

const SuccessDownloadButton = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();
  const downloadButtonContent = (
    <div className='flex bg-bw00 items-center'>
      <IconDownload />
      <div className='text-sm text-bw07 font-metricRSemibold ml-[5px]'>{t('SUCCESS_PAGE.DOWNLOAD')}</div>
    </div>
  );
  return (
    <div className='flex justify-center mt-[16px] bg-bw00 rounded-[100px]'>
      <Button
        onClick={onClick}
        data-testid='SuccessPage-DownloadButton'
        className='flex h-[40px] w-[151px] justify-center items-center border-bw05 rounded-[100px] border-[1px]'
        childElement={downloadButtonContent}
        id=''
      />
    </div>
  );
};

export default SuccessDownloadButton;
